<template>
  <main class="main" id="main">
    <div class="main_top_line">
      <div class="container">
        <div class="top_line_column">
          <div class="m_tl_text">
            <h1>Получи 100 рублей на телефон при любом заказе</h1>
            <p>Введите адрес доставки <a  href="#">Пользовательское соглашение</a> </p>

          </div>
          <div class="m_tl_icons">
            <a href="#"><div class="icon icon1"></div></a>
            <a href="#"><div class="icon icon2"></div></a>
            <a href="#"><div class="icon icon3"></div></a>
            <a href="#"><div class="icon icon4"></div></a>
            <!-- <div class="icon"></div>
            <div class="icon"></div>
            <div class="icon"></div>
            <div class="icon"></div> -->
          </div>
          <div class="m_tl_text">
            <h1>Получи 200 рублей за регистрацию на бонусный счёт</h1>
          </div>
          <button class="green_btn">Получить</button>

        </div>
      </div>
    </div>

    <section class="section_a">
      <div class="container">
        <div class="empty_filters_box"></div>
        <div class="rest_item_wrapper">
          <h3 class="rest_item_title">
            О ресторане
          </h3>

          <rest-block :restaurant.sync="restaurant" :auth.sync="auth" :city.sync="city"></rest-block>

          <div class="restrunt_menu_wrapper">
            <div class="menu_container empty">
              <div class="restrunt_menu">
                <div class="menu_header">
                  <router-link class="menu_link" tag="div" :to="'/restaurant/' + restaurant.id">
                    <span>Меню</span>
                  </router-link>
                  <router-link class="menu_link router-link-exact-active" tag="div" :to="'/restaurant/' + restaurant.id + '/reviews'">
                    <span>Отзывы</span>
                  </router-link>
                </div>
              </div>
              <div class="restaurant_reviews_box">
                  <div class="review_item">
                    <div class="blog_card">
                      <div class="card_side">
                        <div class="comments_part">

                          <div class="comment">
                            <span class="name"></span>
                            <span class="time"></span>
                            <p></p>
                          </div>

                          <div class="comment"  v-for="reply in restaurant.replies" :key="reply.id">
                            <div class="comment_header">
                              <div class="main_info">
                                <span class="name">{{reply.name}}</span>
                                <span class="time">{{reply.date}}</span>
                              </div>
                              <StarRating :rating="reply.rating" :read-only="true" :show-rating="false" :increment="1"></StarRating>
                            </div>
                            <p>{{reply.text}}</p>
                          </div>

                        </div>

                        <div class="comment_application">
                          <div class="comment_application_header">
                            <input type="text" name="" placeholder="Имя" v-model="auth.name">
                            <StarRating :rating="1" :increment="1" v-model="rating"></StarRating>
                          </div>
                          <textarea name="" cols="30" rows="10" placeholder="Комментарий" v-model="text"></textarea>
                          <button type="submit" class="comment_btn" @click="sendComment"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/comment.svg" alt=""></button>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section_b">
      <div class="container">
        <div class="title">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/big_van_24.svg" alt="big_van_24">
          <h1>Круглосуточная доставка еды</h1>
        </div>
        <p>
          Служба доставки еды "ХОЧУ-ПОЕСТЬ.РФ" в городе {{city.name}} - это свыше 1000 блюд и напитков, которые привезут вам домой или в офис без наценок и дополнительной комиссии от лучших ресторанов Вашего города. Есть из чего выбрать! Вы видите то, что Вы заказываете, и точно знаете стоимость, которую нужно заплатить.
        </p>
      </div>
    </section>
  </main>

</template>

<script>
import axios from '@/router/http'
import restBlock from '@/components/restaurant'
import StarRating from 'vue-star-rating'
export default {
  name: 'restaurant',
  props: ['city', 'auth', 'basket', 'geo'],
  components: {restBlock, StarRating},
  data () {
    return {
      restaurant: {id: null, name: null, categories: []},
      price: 0,
      filterWrap: 0,
      itemLimit: 30,
      title: 'ресторан',
      loading: 0,
      text: null,
      rating: 0,
      replies: []
    }
  },
  metaInfo () {
    return {
      title: ' - ' + this.restaurant.name,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          property: 'description',
          content: 'Ресторан ' + this.restaurant.name + ' - ' + this.restaurant.desc
        }
      ]
    }
  },
  created () {
    var id = this.$route.params.id
    this.loading = 1
    axios.get('https://lk.when-hungry.com/mobile/restaurant-get?id=' + id + '&uid=' + this.auth.uid).then(response => {
      this.restaurant = response.data.restaurants
      this.loading = 0
      this.restaurant.show = 1
    })
  },
  watch: {
    $route (to, from) {
      this.loading = 1
      var id = to.params.id
      axios.get('https://lk.when-hungry.com/mobile/restaurant-get?id=' + id + '&uid=' + this.auth.uid).then(response => {
        this.restaurant = response.data.restaurants
        this.loading = 0
        this.restaurant.show = 1
      })
    },
    'restaurant.name' (val) {
      this.title = 'ресторан ' + this.restaurant.name
    }
  },
  methods: {
    sendComment () {
      if (!this.rating) alert('Вы не указали рейтинг')
      else if (!this.text) alert('Вы не оставили отзыв')
      else if (!this.auth.name) alert('Укажите как вас зовут')
      else {
        var id = this.$route.params.id
        var formData = new FormData()
        formData.append('id', id)
        formData.append('uid', this.auth.uid)
        formData.append('name', this.auth.name)
        formData.append('rating', this.rating)
        formData.append('text', this.text)
        axios.post('https://lk.when-hungry.com/mobile/add-comment',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then((response) => {
          this.rating = 0
          this.text = null
          this.restaurant.replies = response.data
        })
      }
    },
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/restaurantReview.vue